import React from 'react';
import HeadBlock from '$/components/global/heading';
import { connect } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import './index.scss';
import HeadingTab from '$/components/global/headingTab';
import {
  getIsCurrentUserBixbyComplianceAdminState,
  getIsCurrentUserCompanyMNPIInfoAdminState,
  getIsCurrentUserCompanyPublicInfoAdminState,
} from '$/store/profile/selectors';
import { getBixbyComplianceFeatureFlagState } from '$/store/release-feature-flags/selectors';
import { AppState } from '$/store';
import DataSiteReconciliationGrid from '$/pages/admin/reconciliations/DataSiteReconciliationGrid';
import NotFound from '$/pages/not-found';

interface IDataSiteReconciliationProps {
  isBixbyComplianceAdmin: boolean;
  isCompanyMNPIInfoAdmin: boolean;
  isCompanyPublicInfoAdmin: boolean;
  isBixbyComplianceEnabled: boolean;
}

const DataSiteReconciliation: React.FC<IDataSiteReconciliationProps> = prop => {
  const { isBixbyComplianceAdmin, isCompanyMNPIInfoAdmin, isCompanyPublicInfoAdmin, isBixbyComplianceEnabled } = prop;
  const baseUrl = `/admin/reconciliations`;
  if (!isBixbyComplianceEnabled) {
    return <DataSiteReconciliationGrid isMnpiUpload={false} />;
  } else if (isBixbyComplianceAdmin) {
    return (
      <>
        <HeadBlock title={'Data Site Reconciliation'}>
          <HeadingTab title={'Reconciliations - Non-MNPI'} link={`${baseUrl}/non-mnpi`} />
          <HeadingTab title={'Reconciliations - MNPI'} link={`${baseUrl}/mnpi`} />
        </HeadBlock>
        <Routes>
          <Route path={'/non-mnpi'} element={<DataSiteReconciliationGrid isMnpiUpload={false} />} />
          <Route path={'/mnpi'} element={<DataSiteReconciliationGrid isMnpiUpload={true} />} />
        </Routes>
      </>
    );
  } else if (isCompanyMNPIInfoAdmin) {
    return <DataSiteReconciliationGrid isMnpiUpload={true} />;
  } else if (isCompanyPublicInfoAdmin) {
    return <DataSiteReconciliationGrid isMnpiUpload={false} />;
  } else {
    return <NotFound />;
  }
};
const mapStateToProps = (state: AppState) => {
  const { isBixbyComplianceAdmin } = getIsCurrentUserBixbyComplianceAdminState(state);
  const { isCompanyMNPIInfoAdmin } = getIsCurrentUserCompanyMNPIInfoAdminState(state);
  const { isCompanyPublicInfoAdmin } = getIsCurrentUserCompanyPublicInfoAdminState(state);
  const { isBixbyComplianceEnabled } = getBixbyComplianceFeatureFlagState(state);

  return {
    isBixbyComplianceAdmin,
    isCompanyMNPIInfoAdmin,
    isCompanyPublicInfoAdmin,
    isBixbyComplianceEnabled,
  };
};

export default connect(mapStateToProps)(DataSiteReconciliation);
